<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
	class?: HTMLAttributes['class']
}>()
</script>

<template>
	<div
		:class="
			cn(
				'rounded-xl border bg-card text-card-foreground shadow-md',
				props.class,
			)
		"
	>
		<slot />
	</div>
</template>
